import React, { createContext, useRef, useState } from "react";

export const LiveChatReconnectContext = createContext();

export const LiveChatReconnectProvider = ({ children }) => {
  // Generic reconnect state
  const [isReconnect, setIsReconnect] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [chatData, setChatData] = useState(null);
  const [telemetryData, setTelemetryData] = useState(null);
  // AWS Connect-specific state
  const [chatSession, setChatSession] = useState(null); // Active ChatJS session
  const [voiceSession, setVoiceSession] = useState(null); // Active Voice session (if applicable)
  const [contactId, setContactId] = useState(null); // AWS Connect contact ID
  const [errorMessage, setErrorMessage] = useState(""); // Error message for chat failures
  const [isAgentTyping, setIsAgentTyping] = useState(false); // Track if agent is typing
  const [agentTypingName, setAgentTypingName] = useState(""); // Store agent's name who is typing
  // Holds events received on a resumed session before the popup subscribes, plus the
  // rejoin notice that must only be sent once the popup is listening.
  const resumeBufferRef = useRef({ listening: false, events: [], pendingNotice: null, session: null });
  return (
    <LiveChatReconnectContext.Provider value={{ 
      resumeBufferRef,
      // Generic reconnect state
      isReconnect, 
      setIsReconnect, 
      isPopupVisible, 
      setIsPopupVisible,
      chatData,
      setChatData,
      telemetryData,
      setTelemetryData,
      // AWS Connect-specific state
      chatSession,
      setChatSession,
      voiceSession,
      setVoiceSession,
      contactId,
      setContactId,
      errorMessage,
      setErrorMessage,
      isAgentTyping,
      setIsAgentTyping,
      agentTypingName,
      setAgentTypingName
    }}>
    {children}
    </LiveChatReconnectContext.Provider>
  );
};
